<template>
  <div>
    <ul
      v-if="type === 'film' || type === 'teleplay' || type === 'cartoon' || type === 'tvshow' || type === 'documentary'"
      class="search-class-list-common"
    >
      <li
        v-for="(item, index) in dataList"
        :key="index"
        class="search-class-list-li"
      >
        <a
          :href="item.tiny_url"
          :uigs="getUigs({ item, index })"
          :title="item.name"
          class="class-item"
        >
          <div class="search-class-img">
            <div
              v-if="item.ipad_play_for_list && item.ipad_play_for_list.fee === '1'"
              class="fee-logo"
            >
              <Logo title="vip-film" />
            </div>
            <CoverImage
              :src="item.v_picurl"
              :is-resize="false"
            />
            <div
              v-if="item.dockey && item.dockey.indexOf('film') > -1"
              class="search-class-score"
            >
              <span>{{ item.score && item.score.length === 1 ? item.score + '.0' : item.score }}</span>
            </div>
            <div
              v-if="item.dockey && item.dockey.indexOf('tvshow') > -1 && item.date"
              class="tvshow-date"
            >
              {{ item.date }}期
            </div>
            <div
              v-if="
                item.dockey &&
                  (item.dockey.indexOf('teleplay') > -1 || item.dockey.indexOf('film') > -1) &&
                  item.ipad_play_for_list
              "
              class="teleplay-jishu"
            >
              <span
                v-if="
                  parseInt(item.ipad_play_for_list.episode, 10) === parseInt(item.ipad_play_for_list.finish_episode, 10)
                "
              >
                {{ item.ipad_play_for_list.finish_episode }}集全
              </span>
              <span v-else-if="parseInt(item.ipad_play_for_list.episode, 10)">
                更新至{{ item.ipad_play_for_list.episode }}集
              </span>
            </div>
          </div>
          <p class="search-class-name">{{ item.name }}</p>
        </a>
        <div
          style="display: none"
          v-html="'<!--n-->'"
        />
      </li>
      <li
        v-if="dataList.length % 3 === 2"
        class="search-class-list-li"
      />
    </ul>
    <div
      v-if="showLoading"
      class="loading-result"
    />
  </div>
</template>

<script>
import CoverImage from './CoverImage.vue';
import Logo from './Logo.vue';

export default {
  components: {
    CoverImage,
    Logo,
  },
  props: {
    dataList: {
      type: Array,
      default: () => [],
    },
    type: {
      type: String,
      default: '',
    },
    getUigs: {
      type: Function,
      default: () => null,
    },
    showLoading: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    routeName() {
      return this.$route.name;
    },
  },
};
</script>

<style lang="scss">
.search-class-list-common {
  font-size: 0;
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  justify-content: space-between;
  position: relative;
  padding: 15px 14px 3px 14px;
}
.search-class-list-li {
  display: inline-block;
  width: 32%;
  vertical-align: top;
}
.search-class-img {
  width: 100%;
  padding-top: 140%;
  border-radius: 5px;
  overflow: hidden;
  position: relative;
  img {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  > span {
    position: absolute;
    display: block;
  }
  &:after {
    content: '';
    position: absolute;
    width: 100%;
    height: 50px;
    background: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.5) 100%);
    border-radius: 0px 0px 5px 5px;
    left: 0;
    bottom: 0;
  }
  .tvshow-date {
    color: #fff;
    font-size: 13px;
    position: absolute;
    bottom: 5px;
    right: 4px;
    z-index: 1;
  }
  .search-class-score {
    position: absolute;
    bottom: 8px;
    right: 4px;
    text-shadow: 0px 0px 3px rgba(0, 0, 0, 0.25);
    color: #fece32;
    font-size: 13px;
    z-index: 2;
    span {
      font-weight: bold;
    }
    &:first-letter {
      font-size: 19px;
    }
  }
}
.search-class-name {
  overflow: hidden;
  text-overflow: ellipsis;
  word-wrap: normal;
  -webkit-line-clamp: 2;
  /*! autoprefixer: ignore next */
  -webkit-box-orient: vertical;
  display: block;
  display: -webkit-box;
  margin: 6px 0 17px;
  font-size: 15px;
  color: rgba(0, 0, 0, 1);
  line-height: 21px;
}
.teleplay-jishu {
  font-size: 13px;
  color: #fff;
  position: absolute;
  bottom: 5px;
  right: 4px;
  z-index: 1;
}
.fee-logo {
  position: absolute;
  top: 4px;
  right: 4px;
  z-index: 1;
}
.class-banner {
  height: 8px;
  background: #f2f2f2;
}
.bottom-banner-adv {
  margin-bottom: 20px;
}
</style>
